<template>
  <div
    class="whatsapp-onboarding-progress"
    role="group"
    :aria-label="progressLabel"
  >
    <div class="whatsapp-onboarding-progress__meta">
      <span class="whatsapp-onboarding-progress__label">
        {{ progressLabel }}
      </span>
    </div>
    <div
      class="whatsapp-onboarding-progress__track"
      role="progressbar"
      :aria-valuenow="stepNumber"
      :aria-valuemin="1"
      :aria-valuemax="totalSteps"
      :aria-label="progressLabel"
    >
      <div
        class="whatsapp-onboarding-progress__fill"
        :style="{ width: `${progressPercent}%` }"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'WhatsappOnboardingProgress',

  props: {
    stepNumber: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
  },

  setup(props) {
    const { t } = useI18n();

    const progressPercent = computed(() => (
      props.totalSteps > 0
        ? Math.round((props.stepNumber / props.totalSteps) * 100)
        : 0
    ));

    const progressLabel = computed(() => (
      t('storeParameters.services.whatsappBusinessParameter.onboarding.nav.progress', {
        current: props.stepNumber,
        total: props.totalSteps,
      })
    ));

    return {
      progressPercent,
      progressLabel,
    };
  },
});
</script>
